export type KpiFiltersConfig = {
  countries?: unknown;
  customerType?: unknown;
  tags?: unknown;
  collections?: unknown;
  vendors?: unknown;
  productTypes?: unknown;
};

export type KpiFiltersState = {
  countries: string[];
  customerType: string;
  tags: string[];
  collections: string[];
  vendors: string[];
  productTypes: string[];
};

function parseStringArray(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  return value.filter((x): x is string => typeof x === 'string');
}

/**
 * Parse conservativo del config filtri salvato in `KpiSection.config`.
 * Serve per retrocompatibilità: le sezioni vecchie non contenevano i filtri.
 */
export function parseKpiFiltersConfig(
  config: KpiFiltersConfig | null | undefined,
): KpiFiltersState {
  const cfg = config ?? {};

  return {
    countries: parseStringArray(cfg.countries),
    customerType: typeof cfg.customerType === 'string' ? cfg.customerType : '',
    tags: parseStringArray(cfg.tags),
    collections: parseStringArray(cfg.collections),
    vendors: parseStringArray(cfg.vendors),
    productTypes: parseStringArray(cfg.productTypes),
  };
}
